module.exports = __webpack_public_path__ + "img/上号教程.3465abfc.png";